import React from "react";
import { ReactComponent as NoResultIcon } from "./NoResult.svg";
import "./NoResults.scss";
import { useQueryRules } from "react-instantsearch-core";

const NoResults = (props) => {
    const { items } = useQueryRules(props);
    const faqData = items
        .map((element) => (element.faqData ? element.faqData : []))
        .flat();
    const faq = faqData[0];
    return (
        <>
            <div className="no-result">
                <NoResultIcon />
                <h2 className="no-result__headline">
                    Leider ergab Ihre Suche keine Treffer
                </h2>
                <p className="no-result__paragraph">
                    Versuchen Sie es erneut mit einer anderen Schreibweise oder
                    mit einem anderen Suchbegriff.
                </p>
                <div className="contact-wrapper">
                    <div className="contact--dropdown">
                        <div className="contact--container">
                            <span className="contact-headline">
                                wir finden das passende Produkt:
                            </span>
                            <div className="section--contact-germany">
                                <div className="listing-item-box">
                                    <div className="listing-item-content">
                                        <span className="listing-item-times">
                                            Mo - Fr 8:00 - 18:00 Uhr
                                        </span>
                                        <span className="listing-item-phone tel">
                                            <a
                                                className="listing-item-link__phone"
                                                href="tel:08008810200"
                                            >
                                                <i className="fa-regular fa-phone"></i>
                                                <span>0800-8810200</span>
                                            </a>
                                        </span>
                                        <span className="listing-item-title">
                                            +49 2159 696400
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="section-contact-callback-germany">
                                <a
                                    className="listing-item-link btn is--primary is--large is--icon-left"
                                    href="https://outlook.office365.com/owa/calendar/InwerkGmbH@inwerk.de/bookings/s/-bs-FR9NiUOQIETmCblT8g2"
                                    target="_blank"
                                    rel="noreferrer noopener nofollow"
                                >
                                    <i className="fa-regular fa-headphones"></i>
                                    <span className="listing-item-title">
                                        Rückruf vereinbaren
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    {faq && (
                        <div className="contact-faq">
                            <span className="contact-faq-headline">
                                {faq.headline && faq.headline}
                            </span>
                            <ul>
                                {faq.elements.map((item, index) => (
                                    <li key={index}>
                                        <i className="fa-regular fa-circle-chevron-right"></i>
                                        <a
                                            href={item.link}
                                            title={item.title}
                                            target={
                                                item.target
                                                    ? item.target
                                                    : "_self"
                                            }
                                        >
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default NoResults;
